module.exports = __webpack_public_path__ + "static/media/javascript-lab2-javascript.cce9b396.JPG";